export enum IdentificationTypeEnum {
  NATIONAL_ID = 'NATIONAL_ID',
  INTERNATION_PASSPORT = 'INTERNATION_PASSPORT',
  DRIVER_LICENSE = 'DRIVER_LICENSE',
  VOTERS_CARD = 'VOTERS_CARD',
  // BVN = 'BVN'
  NIN = 'NIN'
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female'
}

export enum MaritalStatusEnum {
  SINGLE = 'Single',
  MARRIED = 'Married',
  WIDOWED = 'Widowed',
  DIVORCED = 'Divorced',
  SEPERATED = 'Separated'
}

export enum BeneficiaryTypeEnum {
  INDIVIDUAL = 'Individual',
  CORPORATE = 'Corporate'
}

export enum GuardianTypeEnum {
  PRIMARY = 'Primary',
  SUBSTITUTE = 'Substitute'
}

export type SpecialInstruction = {
  instructionTitle: string;
  instructionDescription: string;
};

export enum AccountTypeEnum {
  ADMIN = 'admin',
  CLIENT = 'client'
}
